import React, {useEffect}   from 'react';
import {FormattedMessage, FormattedDate} from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faBlogger,faLinkedin, faGithub} from '@fortawesome/free-brands-svg-icons'
import '../styles.css';
const Footer =() => {
	
		useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);
	
	
	return (  
        <footer class="piedepagina p-y-1" role="contentinfo">
               <div class="container">
		    <p>&copy; {(new Date().getFullYear())}</p>
			
			
            <ul class="redes-sociales">
                <li><a href="https://www.linkedin.com/company/consultoraciberseguridad/" target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a></li>
                <li><a href="https://consultoraciberseguridad.blogspot.com"              target="_blank"><FontAwesomeIcon icon={faBlogger}  /></a></li>
				<li><a href="https://github.com/consultorciberseguridad"                 target="_blank"><FontAwesomeIcon icon={faGithub}   /></a></li>

            </ul>
		
			 <button  onClick={() => {
          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        }}
        style={{
          position: 'fixed',
          padding: '0.8rem ',
          fontSize: '20px',
          bottom: '30px',
          right: '10px',
          backgroundColor: '#2a2a2a',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <FormattedMessage 
								id="app.subir"
								defaultMessage="Subir"
								values={
									{
										name: 'Subir'
								    }
							    }/>
      </button>
			
        </div>
		
		
		
    </footer>
	)
}
export default Footer

